/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "image": {
    "colors_default": "",
    "size_default": "aspect-default",
    "variant_default": "relative block object-cover"
  },
  "caption_colors_default": "text-al-korall-600",
  "caption_size_horizontal": "text-al-category-md",
  "caption_size_vertical": "text-al-category-md",
  "caption_variant_horizontal": "uppercase",
  "caption_variant_vertical": "uppercase",
  "description_colors_default": "text-black",
  "description_size_horizontal": "text-al-body-md lg:container-col-sm-7:text-al-body-lg sm:container-col-sm-7:mt-3",
  "description_size_vertical": "text-al-body-md lg:container-col-sm-7:text-al-body-lg mt-1",
  "description_variant_horizontal": "break-words",
  "description_variant_vertical": "break-words",
  "footer_colors_default": "",
  "footer_size_horizontal": "max-w-full",
  "footer_size_vertical": "max-w-full",
  "footer_variant_horizontal": "col-span-full overflow-hidden",
  "footer_variant_vertical": "overflow-hidden",
  "group_colors_default": "",
  "group_size_horizontal": "gap-0.5",
  "group_size_vertical": "gap-0.5",
  "group_variant_horizontal": "flex flex-col min-w-[0]",
  "group_variant_vertical": "flex flex-col min-w-[0]",
  "header_colors_default": "",
  "header_size_horizontal": "max-w-full",
  "header_size_vertical": "max-w-full",
  "header_variant_horizontal": "col-span-2 overflow-hidden",
  "header_variant_vertical": "overflow-hidden",
  "headline_colors_default": "text-black",
  "headline_size_horizontal": "container-col-lg-12:text-al-headline-xs lg:container-col-lg-7:text-al-headline-lg",
  "headline_size_vertical": "text-al-headline-sm container-col-lg-12:text-al-headline-sm sm:container-col-lg-12:text-al-headline-md md:container-col-lg-12:text-al-headline-lg sm:container-col-lg-7:text-al-headline-md md:container-col-lg-7:text-al-headline-lg lg:container-col-lg-7:text-al-headline-xl sm:container-col-lg-4:text-al-headline-sm",
  "headline_variant_horizontal": "break-words",
  "headline_variant_vertical": "break-words",
  "colors_default": "",
  "size_horizontal": "w-full gap-3 grid-cols-2",
  "size_vertical": "w-full gap-3 auto-rows-min sm:container-col-lg-4:mb-5",
  "variant_horizontal": "grid container-inline",
  "variant_vertical": "grid container-inline"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ArticleTeaserDefault");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;